import Store from '@/abstract/store';
import { definitions } from '@/types/api';

interface Common extends Object {
  name: string;
  code: string;
  token: string;
  role: string;
  headImagePath: string;
  // [key as string]: [key in definitions['User']];
}

class CommonStore extends Store<Common> {
  // eslint-disable-next-line class-methods-use-this
  protected data(): Common {
    return {
      name: '',
      code: '',
      token: '',
      role: '',
      headImagePath: '',
    };
  }

  updateUserInfo(data: definitions['User'] | definitions['LoginUserResponse']) {
    Object.assign(this.state, data);
    sessionStorage.setItem('heroUserStore', JSON.stringify(this.state));
  }

  reset() {
    this.state.name = '';
    this.state.code = '';
    this.state.token = '';
    this.state.role = '';
    this.state.headImagePath = '';
  }
}

export default new CommonStore();
